export const SharedUnstakeStatus = {
  REQUESTED: "REQUESTED",
  IN_UNBONDING_PERIOD: "IN_UNBONDING_PERIOD",
  READY_FOR_WITHDRAW: "READY_FOR_WITHDRAW",
  WITHDRAWN: "WITHDRAWN",
  CANCELED: "CANCELED",
} as const;

export type SharedUnstakeStatus =
  (typeof SharedUnstakeStatus)[keyof typeof SharedUnstakeStatus];

export const SharedUnstakeType = {
  PARTIAL: "PARTIAL",
  FULL: "FULL",
} as const;

export type SharedUnstakeType =
  (typeof SharedUnstakeType)[keyof typeof SharedUnstakeType];

export const ManagedUnstakeStatus = {
  SUBMITTED: "SUBMITTED",
  PROCESSING: "PROCESSING",
  PROCESSED: "PROCESSED",
  CANCELLED: "CANCELLED",
  WITHDRAWN: "WITHDRAWN",
} as const;

export type ManagedUnstakeStatus =
  (typeof ManagedUnstakeStatus)[keyof typeof ManagedUnstakeStatus];
